import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=fad0780a"
import script from "./NewOrder.vue?vue&type=script&lang=js"
export * from "./NewOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports